/* tslint:disable */
/* eslint-disable */
/**
 * Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface CompanyPasswordResetDTO
 */
export interface CompanyPasswordResetDTO {
	/**
	 *
	 * @type {string}
	 * @memberof CompanyPasswordResetDTO
	 */
	email?: string | null;
}

export function CompanyPasswordResetDTOFromJSON(
	json: any
): CompanyPasswordResetDTO {
	return CompanyPasswordResetDTOFromJSONTyped(json, false);
}

export function CompanyPasswordResetDTOFromJSONTyped(
	json: any,
	ignoreDiscriminator: boolean
): CompanyPasswordResetDTO {
	if (json === undefined || json === null) {
		return json;
	}
	return {
		email: !exists(json, "email") ? undefined : json["email"],
	};
}

export function CompanyPasswordResetDTOToJSON(
	value?: CompanyPasswordResetDTO | null
): any {
	if (value === undefined) {
		return undefined;
	}
	if (value === null) {
		return null;
	}
	return {
		email: value.email,
	};
}
